import queryString from 'query-string';

export const makeBackUrl = ({ pathname, search }: { pathname: string; search: string }): string => {
  return encodeURIComponent(pathname + search);
};

export const parseBackUrl = (location: { search: string }, fallback: string): string => {
  const backTo = queryString.parse(location.search)?.back_to as string;
  if (!!backTo && backTo.match(/^\/.*/)) {
    return backTo;
  } else {
    return fallback;
  }
};

export const toBlob = (base64: string, mimeCtype: string) => {
  const bin = atob(base64);
  const buffer = new Uint8Array(bin.length).map((_, i) => bin.charCodeAt(i));
  return new Blob([buffer.buffer], { type: mimeCtype });
};
